import React, { useState} from 'react'
import moment from 'moment';
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import MenuItem from '@mui/material/MenuItem';
import { TextValidator, ValidatorForm, SelectValidator, } from 'react-material-ui-form-validator';

const LegalClaimDetails = (props) => {
  const classes = useStyle();
  console.log("legal claim details props", props)

  const [dateOfIncident, setDateOfIncident] = useState(props.eventDate);
  const [natureOfCase, setNatureOfCase] = useState(props.claimState.nature_of_case || '');
  const [typeOfDispute, setTypeOfDispute] = useState(props.claimState.type_of_dispute || '');
  const [briefDescription, setBriefDescription] = useState(props.claimState.brief_description || '');

  const caseTypesData = {
    "Criminal Cases": [
      "Assault",
      "Murder",
      "Culpable Homicide",
      "Malicious Damage to Property",
      "Road Traffic Accident (RTA) - traffic offence",
      "Theft",
      "Unlawful entry",
      "Domestic violence",
      "Rape",
      "Fraud",
      "Malicious damage of property",
      "Theft of trusted property",
      "Prospecting",
      "Criminal abuse of power",
      "Extortion",
      "Indecent assault",
      "Aggravated indecent assault",
      "Having sexual intercourse with a minor",
      "Public violence",
      "Robbery",
      "Corruption",
      "Bribery",
      "Compounding",
      "Kidnapping",
      "Forgery",
      "Receiving stolen property",
      "Trespass",
      "Contempt of court",
      "Public indecency",
      "Smuggling of goods",
      "Possession of dangerous drugs",
      "Police charge",
      "Shape"
    ],
    "Labour Cases": [
      "Disciplinary Hearing",
      "Misconduct",
      "Police Hearing",
      "Transfer contestation",
      "Absenteeism",
      "Abuse of office",
      "Dismissal",
      "Board of suitability",
      "Report writing",
      "Unpaid Wages",
      "Workplace harassment",
      "Cyber bullying",
      "Shape"
    ],
    "Civil Cases": [
      "Protection order (can also be criminal in nature depending on context)",
      "Recession of judgement",
      "Contractual disagreements (breach of contracts)",
      "Land Dispute",
      "Child Custodianship and guardianship",
      "Divorce",
      "Maintenance Civil",
      "Sharing of property",
      "Deceased estate planning",
      "Adultery damages",
      "Spoliation order",
      "Eviction",
      "Delictual damages",
      "Civil expenses claims",
      "Civil appeal",
      "Peace order",
      "Agreement of sale",
      "Family trust",
      "Negligence",
      "Notice of opposition",
      "Notice of set down",
      "Maintenance Criminal (hybrid but often filed under criminal)",
      "Compelling",
      "Legal advice"
    ]
  };

  // Get available nature of case options
  const natureOfCaseOptions = Object.keys(caseTypesData);

  // Get available dispute types based on selected nature of case
  const getAvailableDisputes = () => {
    if (natureOfCase && caseTypesData[natureOfCase]) {
      return caseTypesData[natureOfCase];
    }
    return [];
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    
    if (name === "incidentDate") {
      setDateOfIncident(value);
      props.setAdditionalState("incident_date", value);
    }
    if (name === "natureOfCase") {
      setNatureOfCase(value);
      // Reset type of dispute when nature of case changes
      setTypeOfDispute('');
      props.setAdditionalState("nature_of_case", value);
    }
    if (name === "typeOfDispute") {
      setTypeOfDispute(value);
      props.setAdditionalState("type_of_dispute", value);
    }
    if (name === "briefDescription") {
      setBriefDescription(value);
      props.setAdditionalState("brief_description", value);
    }
    
    props.setAdditionalState("product_code", props.eventData.product_code);
    props.setAdditionalState("policy_start_date", props.eventData.start_date);
  }

  const waitingPeriodTypes = ['Divorce', 'Agreement of sale', 'Deceased estate planning'];
  const policyStartDate = props.eventData && props.eventData.start_date;
  const isWaitingPeriodDispute = waitingPeriodTypes.indexOf(typeOfDispute) !== -1;
  const isInWaitingPeriod = isWaitingPeriodDispute && policyStartDate && dateOfIncident &&
    moment(dateOfIncident).diff(moment(policyStartDate), 'months') < 6;
  const waitingPeriodEndDate = policyStartDate
    ? moment(policyStartDate).add(6, 'months').format('DD MMM YYYY')
    : '';

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4>Claim Information For Legal Claim</h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => { }}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>

          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="incidentDate"
              label="Incident Date"
              name='incidentDate'
              value={dateOfIncident}
              disabled={true}
              // onChange={handleChange}
                style={{ width: "100%" }}
              fullWidth
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please enter date of incident']}
            
            />
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
            <SelectValidator
              id="natureOfCase"
              label="Nature of Case"
              name="natureOfCase"
              value={natureOfCase}
              onChange={handleChange}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please select nature of case']}
              style={{ width: "100%" }}
              sx={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.005em",
                color: "#000000",
                      }} 
            >
             {natureOfCaseOptions.map((caseType, index) => (
                <MenuItem key={index} value={caseType}
                 sx={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.005em",
                color: "#000000",
                      }} >
                  {caseType}
                </MenuItem>
              ))}
            </SelectValidator>
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
            <SelectValidator
              id="typeOfDispute"
              label="Type of Dispute"
              name="typeOfDispute"
              value={typeOfDispute}
              onChange={handleChange}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please select type of dispute']}
              style={{ width: "100%" }}
              disabled={!natureOfCase} // Disable if no nature of case is selected
              sx={{
                 fontFamily: "Open Sans",
                 fontStyle: "normal",
                 fontWeight: 300,
                 fontSize: "12px",
                 lineHeight: "16px",
                 letterSpacing: "0.005em",
                 color: "#000000",
                      }} 
            >
              {getAvailableDisputes().map((dispute, index) => (
                <MenuItem key={index} value={dispute}  
                sx={{
                 fontFamily: "Open Sans",
                 fontStyle: "normal",
                 fontWeight: 300,
                 fontSize: "12px",
                 lineHeight: "16px",
                 letterSpacing: "0.005em",
                 color: "#000000",
                      }} >
                  {dispute}
                </MenuItem>
              ))}
            </SelectValidator>
          </Grid>

          <Grid item xs={12} md={12} sm={12}>
            <TextValidator
              id="briefDescription"
              label="Brief Description of the Incident"
              name="briefDescription"
              value={briefDescription}
              onChange={handleChange}
              fullWidth
              style={{ width: "100%" }}
              multiline
              rows={4}
              variant="outlined"
              validators={['required', 'maxStringLength:500']}
              errorMessages={['Please provide a brief description', 'Maximum 500 characters allowed']}
              inputProps={{ maxLength: 500 }}
            />
          </Grid>

        </Grid>

        {isInWaitingPeriod && (
          <Grid container spacing={2} style={{ marginTop: '10px' }}>
            <Grid item xs={12}>
              <p style={{ color: '#8F191C', fontWeight: 'bold', padding: '10px', background: '#fdecea', borderRadius: '4px' }}>
                This type of dispute (<strong>{typeOfDispute}</strong>) has a 6-month waiting period from the policy start date.
                You will be able to submit this claim from <strong>{waitingPeriodEndDate}</strong>.
              </p>
            </Grid>
          </Grid>
        )}

      </ValidatorForm>
    </>
  )
}

export default LegalClaimDetails;
